module.exports = (__webpack_require__(3))(67);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FileModel.js from dll-reference girder_lib
// module id = 25
// module chunks = 0